/** HTTP base URL for Colyseus (Client expects `http://` / `https://`, not `ws://`). */
export function colyseusHttpUrl(): string {
  const c = import.meta.env.VITE_COLYSEUS_URL;
  if (typeof c === 'string' && c.length > 0) {
    return c
      .replace(/^ws:\/\//i, 'http://')
      .replace(/^wss:\/\//i, 'https://');
  }
  const ws = import.meta.env.VITE_WS_URL;
  if (typeof ws === 'string' && ws.length > 0) {
    return ws
      .replace(/^ws:\/\//i, 'http://')
      .replace(/^wss:\/\//i, 'https://');
  }
  return 'http://localhost:3333';
}
